export default __webpack_public_path__ + "static/media/31.863d0fff.webp";